import { render } from "./FeedItem.vue?vue&type=template&id=bca70504"
const script = {}
script.render = render

export default script